import React, { useState, useEffect, useRef } from "react";

import axios from "axios";
import { IMG_URL } from "../../config";

import Dashboard from "../Dashboard/Dashboard";
import "./Profile.css";
// import pink from "../../images/down-pink.svg";
// import gren from "../../images/down-gren.svg";

import { END_URL } from "../../config";
import gren from "../../images/test2.jpg";
import pk from "../../images/profile-pic-svg.svg";
import gn from "../../images/green.png";
import loadimg from "../../images/loader_wish.gif";

function Profile({ onLoginChange, ProfileChange, globaltest }) {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [countryId, setCountryId] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [editMode, setEditMode] = useState(true);

  const token = localStorage.getItem("token");
  const [show, setShow] = useState(null);

  const [postCode, setPostCode] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [profileExists, setProfileExists] = useState(false);
  const [countries, setCountries] = useState([]);
  const [profilePic, setProfilePic] = useState("");
  const [profilePicFile, setProfilePicFile] = useState(null);

  const [ProfileContent, setProfileContent] = useState([]);

  const [loading, setLoading] = useState(true);

  const formRef = useRef();

  useEffect(() => {
    if (!token) {
      window.scrollTo({ top: 0, behavior: "smooth" });
      onLoginChange(true);
    }
  }, [token]);

  useEffect(() => {
    fetchProfile();
  }, []);

  const fetchProfile = async () => {
    if (!token) {
      setErrorMessage("User is not logged in. Token not found.");
      return;
    }

    try {
      setLoading(true);

      const response = await fetch(`${END_URL}/profiles`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.ok) {
        const data = await response.json();
        const firstName = data.profile.first_name || "";
        const lastName = data.profile.last_name || "";

        setFirstName(firstName || "");
        setLastName(lastName || "");
        setEmail(data.user.email || "");

        setPhone(data.profile.phone_number || "");
        setCity(data.profile.city || "");
        setState(data.profile.state || "");
        setCountryId(data.profile?.country_id || "");
        setPostCode(data.profile?.post_code || "");
        setProfilePic(data.profile.profilepic || "");

        setProfileContent(data.profile_content);

        setProfileExists(true);

        setEditMode(false);

        setLoading(false);
      } else {
        setErrorMessage("Failed to fetch profile. Please try again.");
      }
    } catch (error) {
      setErrorMessage("Error fetching profile. Please try again.");
    }
  };

  const validateForm = () => {
    if (!email.includes("@")) {
      setErrorMessage("Invalid email format.");
      return false;
    }
    // Add more validation rules as needed
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    const token = localStorage.getItem("token");
    const formData = new FormData();
    formData.append("first_name", firstName);
    formData.append("last_name", lastName);
    formData.append("email", email);
    formData.append("phone_number", phone);
    formData.append("city", city);
    formData.append("state", state);
    formData.append("country_id", countryId);
    formData.append("post_code", postCode);

    // Handle file (image) upload, e.g. profilePicFile
    if (profilePicFile) {
      formData.append("profilepic", profilePicFile);
    }

    try {
      const response = await fetch(`${END_URL}/profiles`, {
        method: "POST", // Or 'PUT' if updating
        headers: {
          Authorization: `Bearer ${token}`,
          // DO NOT set 'Content-Type'! Browser will set it for FormData
        },
        body: formData,
      });

        const data = await response.json();

        console.log(data,'dsadsdsa');

        ProfileChange(true);
        setShowModal(true);
        setProfileExists(true);
        setEditMode(false);

        if (profilePicFile) {
          setProfilePic(URL.createObjectURL(profilePicFile)); // Optimistic preview
        }

        localStorage.setItem(
          "profile_url",
          `${IMG_URL}/d0/${data.profile_url.replace(/^\/?/, "")}`
        );
         
    } catch (error) {
      setErrorMessage("Error saving profile. Please try again.");
    }
  };

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await axios.get(`${END_URL}/countries`);

        // Check if response.data is an array
        if (
          response.data &&
          response.data.countries &&
          Array.isArray(response.data.countries)
        ) {
          const countryNames = response.data.countries
            .map((country_id) => country_id.name.common)
            .sort((a, b) => a.localeCompare(b));

          console.log(response.data.countries, "yrtyr");

          setCountries(response.data.countries);
        } else {
          console.error("Data is not in the expected format:", response.data);
          // Optionally set a default value for countries or show an error message
          setCountries([]);
        }
      } catch (error) {
        console.error("Failed to fetch countries:", error);
      }
    };

    fetchCountries();
  }, []);

  const fileInputRef = useRef();

  function handlePicChange(e) {
    if (e.target.files && e.target.files[0]) {
      setProfilePicFile(e.target.files[0]);
      setProfilePic(""); // clear the old if replacing
    }
  }

  const handleProfilePicDelete = async () => {
    const token = localStorage.getItem("token");
    try {
      const response = await fetch(`${END_URL}/profilepic`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.ok) {
        setProfilePic("");
        setProfilePicFile(null);
        // Optionally show a success message
      } else {
        setErrorMessage("Failed to delete profile picture.");
      }
    } catch (error) {
      setErrorMessage("Error deleting profile picture.");
    }
  };

  return (
    <div>
      <div className="result-cont profileCont">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 col-sm-12 col-md-3 col-lg-3 das-res">
              <Dashboard globaltest={globaltest} />

              {ProfileContent  && ( 

                <div className={`col-12 col-sm-12 col-md-3 col-lg-3 profile-right profile-left-side`} >
                
                      <div className="profile-right-div">
                        <h2>Note</h2>
                        <div className="row">

                          <div className="col-12 col-sm-12 col-md-12 profile-rt-one" style={{ background: ProfileContent?.profile_note_1_bg }} dangerouslySetInnerHTML={{ __html:ProfileContent?.profile_note_1 }} />
                          
                          <div className="col-12 col-sm-12 col-md-12 profile-rt-one" style={{ background: ProfileContent?.profile_note_2_bg }} dangerouslySetInnerHTML={{ __html:ProfileContent?.profile_note_2 }} />

                          <div className="col-12 col-sm-12 col-md-12 profile-rt-one" style={{ background: ProfileContent?.profile_note_3_bg }} dangerouslySetInnerHTML={{ __html:ProfileContent?.profile_note_3 }} />

                        </div>
                      </div>
                </div>
              )}

            </div>

            <div className={`col-12 col-sm-12 col-md-7 col-lg-7 profile-mid`}>
              {/* {loading ? (

                <div className="profile-inner">
                  
                      <div className="profile-btnDiv">
                        <div className="skeleton3 skeleton3-line" style={{ width: '150px', height: '24px' }}></div>
                        <div style={{ display: 'flex', gap: '10px' }}>
                          <div className="skeleton3 skeleton3-btn"></div>
                          <div className="skeleton3 skeleton3-btn"></div>
                        </div>
                      </div>

                      <div className="profile-form" style={{ marginTop: '20px' }}>
                        <div className="skeleton3 skeleton3-avatar"></div>
                        <div className="skeleton3 skeleton3-line" style={{ width: '70%' }}></div>
                        <div className="skeleton3 skeleton3-line" style={{ width: '60%' }}></div>
                        <div className="skeleton3 skeleton3-line" style={{ width: '90%' }}></div>
                        <div className="skeleton3 skeleton3-line" style={{ width: '80%' }}></div>
                        <div className="skeleton3 skeleton3-line" style={{ width: '70%' }}></div>
                        <div className="skeleton3 skeleton3-line" style={{ width: '60%' }}></div>
                        <div className="skeleton3 skeleton3-line" style={{ width: '80%' }}></div>
                        <div className="skeleton3 skeleton3-line" style={{ width: '50%' }}></div>
                      </div>

                  </div>

              ) : ( */}
                <div className="profile-inner">
                  <div className="profile-btnDiv">
                    <h5>Profile</h5>
                    <div className="prof-butt">
                      {!editMode ? (
                        <button
                          type="button"
                          className="btn btn664-primary profile-btn"
                          onClick={() => setEditMode(true)}
                        >
                          Edit Profile
                        </button>
                      ) : (
                        <div style={{ display: "flex", gap: "10px" }}>
                          <button
                            type="button"
                            onClick={() => {
                              if (formRef.current)
                                formRef.current.requestSubmit();
                            }}
                            className="btn btn-primary profile-btn"
                          >
                            Save Changes
                          </button>

                          <button
                            type="button"
                            className="btn btn-secondary profile-btn"
                            onClick={() => setEditMode(false)}
                          >
                            Cancel
                          </button>
                        </div>
                      )}
                    </div>
                  </div>

                  {errorMessage && (
                    <div className="alert alert-danger profile-error">
                      {errorMessage}
                    </div>
                  )}

                  <div className="profile-form">
                    {/* The visible image */}
                    <div
                      style={{
                        cursor: editMode ? "pointer" : "inherit",
                        display: "inline-block",
                      }}
                    >
                      {(profilePicFile || profilePic) && (
                        <img
                          src={
                            profilePicFile
                              ? URL.createObjectURL(profilePicFile)
                              : profilePic
                              ? `${IMG_URL}/d0/${profilePic.replace(
                                  /^\/?/,
                                  ""
                                )}`
                              : ""
                          }
                          onClick={
                            editMode
                              ? () => fileInputRef.current.click()
                              : undefined
                          }
                        />
                      )}

                      {!profilePic && !profilePicFile && (
                        <>
                          <a
                            onClick={() => fileInputRef.current.click()}
                            style={{ cursor: "pointer" }}
                          >
                            <img src={pk} alt="Upload Placeholder" />
                          </a>

                          <input
                            type="file"
                            ref={fileInputRef}
                            accept="image/*"
                            style={{ display: "none" }}
                            onChange={handlePicChange}
                          />
                        </>
                      )}

                      {editMode && profilePic && (
                        <button type="button" onClick={handleProfilePicDelete}>
                          x
                        </button>
                      )}

                      {editMode && (
                        <input
                          type="file"
                          ref={fileInputRef}
                          accept="image/*"
                          style={{ display: "none" }}
                          onChange={handlePicChange}
                        />
                      )}
                    </div>

                    <form ref={formRef} onSubmit={handleSubmit}>
                      {/* First Name */}
                      <div className="form-group">
                        <label htmlFor="firstName">
                          First Name {editMode && <span>*</span>}{" "}
                        </label>
                        {editMode ? (
                          <input
                            type="text"
                            className="form-control"
                            id="firstName"
                            value={firstName}
                            onChange={(e) => setFirstName(e.target.value)}
                          />
                        ) : (
                          <div className="form-control-static">{firstName}</div>
                        )}
                      </div>

                      {/* Last Name */}
                      <div className="form-group">
                        <label htmlFor="lastName">
                          Last Name {editMode && <span>*</span>}{" "}
                        </label>
                        {editMode ? (
                          <input
                            type="text"
                            className="form-control"
                            id="lastName"
                            value={lastName}
                            onChange={(e) => setLastName(e.target.value)}
                          />
                        ) : (
                          <div className="form-control-static">{lastName}</div>
                        )}
                      </div>

                      <div className="form-group">
                        <label htmlFor="email">
                          Email Address {editMode && <span>*</span>}{" "}
                        </label>
                        {editMode ? (
                          <input
                            type="email"
                            className="form-control"
                            id="email"
                            readonly
                            value={email}
                            readOnly
                            onChange={(e) => setEmail(e.target.value)}
                          />
                        ) : (
                          <div className="form-control-static">{email}</div>
                        )}
                      </div>

                      {/* Phone */}
                      <div className="form-group">
                        <label htmlFor="phone">
                          Phone Number {editMode && <span>*</span>}{" "}
                        </label>
                        {editMode ? (
                          <input
                            type="tel"
                            className="form-control"
                            id="phone"
                            value={phone}
                            onChange={(e) => setPhone(e.target.value)}
                          />
                        ) : (
                          <div className="form-control-static">{phone}</div>
                        )}
                      </div>

                      {/* City */}
                      <div className="form-group">
                        <label htmlFor="city">
                          City {editMode && <span>*</span>}{" "}
                        </label>
                        {editMode ? (
                          <input
                            type="text"
                            className="form-control"
                            id="city"
                            value={city}
                            onChange={(e) => setCity(e.target.value)}
                          />
                        ) : (
                          <div className="form-control-static">{city}</div>
                        )}
                      </div>

                      {/* State */}
                      <div className="form-group">
                        <label htmlFor="state">
                          State {editMode && <span>*</span>}{" "}
                        </label>
                        {editMode ? (
                          <input
                            type="text"
                            className="form-control"
                            id="state"
                            value={state}
                            onChange={(e) => setState(e.target.value)}
                          />
                        ) : (
                          <div className="form-control-static">{state}</div>
                        )}
                      </div>

                      {/* Country */}
                      <div className="form-group">
                        <label htmlFor="Country">
                          Country {editMode && <span>*</span>}{" "}
                        </label>
                        {editMode ? (
                          <select
                            className="form-control"
                            id="Country"
                            value={countryId}
                            onChange={(e) => setCountryId(e.target.value)}
                          >
                            <option value="">Select Country</option>
                            {countries.map((country) => (
                              <option key={country.id} value={country.id}>
                                {country.name}
                              </option>
                            ))}
                          </select>
                        ) : (
                          <div className="form-control-static">
                            {countries.find((c) => c.id === countryId)?.name}
                          </div>
                        )}
                      </div>

                      {/* Post Code */}
                      <div className="form-group">
                        <label htmlFor="postCode">
                          Post Code {editMode && <span>*</span>}{" "}
                        </label>
                        {editMode ? (
                          <input
                            type="text"
                            className="form-control"
                            id="postCode"
                            value={postCode}
                            onChange={(e) => setPostCode(e.target.value)}
                          />
                        ) : (
                          <div className="form-control-static">{postCode}</div>
                        )}
                      </div>

                    </form>
                  </div>
                </div>
              {/* // )} */}

              
              {ProfileContent  && ( 

                <div className={`col-12 col-sm-12 col-md-3 col-lg-3 profile-right profile-bottom-side`} >
                
                      <div className="profile-right-div">
                          <h2>Note</h2>
                        <div className="row">

                          <div className="col-12 col-sm-12 col-md-12 profile-rt-one" style={{ background: ProfileContent?.profile_note_1_bg }} dangerouslySetInnerHTML={{ __html:ProfileContent.profile_note_1 }} />
                          
                          <div className="col-12 col-sm-12 col-md-12 profile-rt-one" style={{ background: ProfileContent?.profile_note_2_bg }} dangerouslySetInnerHTML={{ __html:ProfileContent.profile_note_2 }} />

                          <div className="col-12 col-sm-12 col-md-12 profile-rt-one" style={{ background: ProfileContent?.profile_note_3_bg }} dangerouslySetInnerHTML={{ __html:ProfileContent.profile_note_3 }} />

                        </div>
                      </div>
                </div>
              )}
 
            </div>

              {ProfileContent && token && ( 

                <div className={`col-12 col-sm-12 col-md-3 col-lg-3 profile-right`} >
                
                      <div className="profile-right-div">
                         <h2>Note</h2>
                        <div className="row">

                          <div className="col-12 col-sm-12 col-md-12 profile-rt-one" style={{ background: ProfileContent?.profile_note_1_bg }} dangerouslySetInnerHTML={{ __html:ProfileContent.profile_note_1 }} />
                          
                          <div className="col-12 col-sm-12 col-md-12 profile-rt-one" style={{ background: ProfileContent?.profile_note_2_bg }} dangerouslySetInnerHTML={{ __html:ProfileContent.profile_note_2 }} />

                          <div className="col-12 col-sm-12 col-md-12 profile-rt-one" style={{ background: ProfileContent?.profile_note_3_bg }} dangerouslySetInnerHTML={{ __html:ProfileContent.profile_note_3 }} />

                        </div>
                      </div>
                </div>
              )}

          </div>
        </div>
      </div>

      {showModal && (
        <div className="modal-overlay">
          <div className="modal-content-custom">
            <div className="modal-header-custom">
              <h5 className="modal-title-custom">Success</h5>
              <button
                className="close"
                onClick={() => setShowModal(false)}
                style={{
                  background: "transparent",
                  border: "none",
                  fontSize: "1.5rem",
                  cursor: "pointer",
                }}
              >
                &times;
              </button>
            </div>
            <div className="modal-body-custom">Profile saved successfully!</div>
            <div className="modal-footer-custom">
              <button
                className="btn-custom"
                onClick={() => setShowModal(false)}
              >
                OK
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Profile;
